import {Component, cloneElement} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import {Control} from '-/components/fields/Control';
import {rem} from '-/styles/utils';

const radioGroupStyles = theme => ({
    ul: {
        listStyle: 'none',
        background: '#fff',
        borderLeft: '1px solid gainsboro',
        borderRight: '1px solid gainsboro',
        padding: 15
    },
    li: {
        fontFamily: theme.fontFamily,
        color: '#4a4a4a',
        display: 'inline-block',
        marginRight: 25,
        marginTop: 5,
        marginBottom: 5,

        '& label': {
            marginLeft: 5
        }
    },
    verticalLi: {
        display: 'block',
        margin: `${rem(15)} 0`
    }
})

class RadioGroupCls extends Component {
    static propTypes = {
        vertical: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        vertical: false
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const {onChange} = this.props;
        if (onChange) {
            onChange(e.target.value);
        }
    }

    render() {
        const {vertical, label, labelWidth, onChange, classes = {}} = this.props;
        const cls = classNames(classes.li, {
            [classes.verticalLi]: vertical
        });
        return (
            <Control labelWidth={labelWidth}>
                <ul label={label} className={classes.ul}>
                    {this.props.children.map((child, i) => {
                        if (!child) {
                            return false;
                        }
                        if (onChange && child.type === Radio) {
                            child = cloneElement(child, {onChange: this.handleChange});
                        }
                        return (
                            <li key={i} className={cls}>
                                {child}
                                {child.props.label ? (
                                    <label
                                        htmlFor={child.props.id}>
                                        {child.props.label}
                                    </label>
                                ) : null}
                            </li>
                        );
                    })}
                </ul>
            </Control>
        );
    }
}

export class Radio extends Component {
    get checked() {
        return this.refs.radio.checked;
    }

    render() {
        return <input ref="radio" {...this.props} type="radio" />;
    }
}

export const RadioGroup = injectSheet(radioGroupStyles)(RadioGroupCls);
